/**
 * @name          jQuery Boilerplate
 * @version       1.1
 * @lastmodified  2016-09-12
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        JR, VI
 *
 * based on: http://jqueryboilerplate.com/
 */

(function($, window, document, undefined) {
  'use strict';

  var pluginName = 'errormessage',
    defaults = {
      resultTemplate: global.configuration.data.tpl.errormessage, // errormessage.hbs in /app/resources/templates/errormessage.hbs
      resultTemplateDetail: global.configuration.data.tpl.errormessageDetail, // errormessageDetail.hbs
      noResultTemplateDetail:
        global.configuration.data.tpl.noResultTemplateDetail, // noResultTemplateDetail.hbs
    };

  // The actual plugin constructor
  function Plugin(element, options) {
    var self = this;
    self.$element = $(element);
    self.isMobile = $(window).width() < 768;
    self.options = $.extend({}, defaults, options);
    self.init();
  }

  // methods
  var methods = {
    init: function() {
      var self = this;
      self.loadElements();
    },

    loadElements: function() {
      var self = this;

      self.isDetail = self.$element.hasClass('errormessage--detail');

      var params = {
        area: self.getAreas(),
      };

      var decodeString = function(string) {
        var r = /\\u([\d\w]{4})/gi;
        var decodedString = string.replace(r, function(match, grp) {
          return String.fromCharCode(parseInt(grp, 16));
        });
        return decodedString.replace(/\\/g, '');
      };

      jQuery.ajaxSettings.traditional = true;

      // load search JSON data
      $.ajax({
        url: self.options.messagesUrl,
        data: params,
        dataType: 'json',
        success: function(data) {
          if (data.length === 0) {
            // If no results (emtpy array) render no result message

            self.displayNoResultMessage();
          } else {
            for (var i = 0; i < data.length; i++) {
              /*jshint camelcase: false */
              data[i].id = decodeString(data[i].id);
              data[i].bereich = decodeString(data[i].bereich);
              data[i].adresse = decodeString(data[i].adresse);
              data[i].erstelldatum = decodeString(
                self.transformDate(data[i].erstelldatum)
              );
              data[i].text = decodeString(data[i].text);
              data[i].titel = decodeString(data[i].title);
              data[i].detailURL = self.options.detailURL + '#' + data[i].id;
            }

            // build result list
            var html = '';
            if (!self.isDetail) {
              html = self.options.resultTemplate(data);
            } else {
              html = self.options.resultTemplateDetail(data);
            }

            self.$element.append(html);

            // load slider
            if (!self.isDetail) {
              setTimeout(function() {
                // @deprecated
                // self.$element.find('.errormessage__slider').slider();
                // self.$element.on('before.slide.bxslider', function (e) {
                // 	var height = $(window).width() <= 1024 ? e.slideElement.outerHeight() + $('.bx-controls.bx-has-controls-direction.bx-has-pager').height() + 50 : e.slideElement.outerHeight();
                // 	self.animateToHeight(height);
                // });

                var $el = self.$element.find('.errormessage__slider');

                var swiper = $el.swiperSlider();

                swiper.on('slideChange', function() {
                  console.log('on slideChange');
                  console.log(this.slides, this.activeIndex);

                  var height =
                    $(window).width() <= 1024
                      ? e.slideElement.outerHeight() +
                        $('.swiper-pagination').height() +
                        50
                      : e.slideElement.outerHeight();
                  self.animateToHeight(height);
                });

                self.reCalculateHeight();

                FontDetect.onFontLoaded('Thesans', function() {
                  setTimeout(function() {
                    self.reCalculateHeight();
                    self.$element
                      .find('.errormessage__slider')
                      .removeClass('errormessage--loading');
                  }, 1000);
                });
                $(window).trigger('resize');
              }, 500);
            } else {
              // jump to message
              if (location.hash.replace('#', '').length > 0) {
                var isIE = global.configuration.get('global.IE');
                var timeout = 1;

                if (isIE) {
                  timeout = 500;
                }

                setTimeout(function() {
                  $(document).scrollTop(
                    $('#m' + location.hash.replace('#', '')).offset().top -
                      $('header.header').outerHeight() -
                      25
                  );
                }, timeout);
              }
            }
          }
        },
        error: function() {
          self.displayNoResultMessage();
        },
      });
    },

    transformDate: function(date) {
      return date.slice(0, -5);
    },

    getAreas: function() {
      var self = this;

      return self.options.client.split(';');
    },

    displayNoResultMessage: function() {
      var self = this;

      if (self.isDetail) {
        var data = {
          noMsgHeadline: self.$element.data('nomsgheadline'),
          noMsgText: self.$element.data('nomsgtext'),
        };
        var html = '';
        html = self.options.noResultTemplateDetail(data);

        self.$element.append(html);
      }
    },

    reCalculateHeight: function() {
      var paddingTop = $('.header--sticky').innerHeight();
      // $('main.content').css('padding-top', paddingTop);
    },

    animateToHeight: function(paddingTop) {
      paddingTop = $('.header--sticky').innerHeight();
      // console.log('jquery.errormessage ' + paddingTop);
      // $('main.content').animate({'padding-top': paddingTop}, 500);
    },
  };

  // build
  $.extend(Plugin.prototype, methods);

  // A really lightweight plugin wrapper around the constructor,
  // preventing against multiple instantiations
  $.fn[pluginName] = function(options) {
    this.each(function() {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName, new Plugin(this, options));

        // DEV-note: include failsafe events only if needed
        // trigger ready event on element
        //$.triggerFailsafeEvent($(this), 'plugin_' + pluginName + '.ready');
      }
    });

    // trigger ready event globally
    //if(this.length > 0) {
    //    $.triggerFailsafeEvent($(window), 'plugin_' + pluginName + '.ready_all');
    //}

    return this;
  };
})(jQuery, window, document);
